import { Component, OnInit, Output, Input } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { AuthorizationService } from "@src/app/helpers/authorization.service";

import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { UieventhubService } from "@src/app/helpers/uieventhub/uieventhub.service";
import { Auth } from "aws-amplify";

import { PersonOrganization } from "./model/personorganization";
import { ImagestoreService } from "@src/app/helpers/imagestore.service";

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TopNavService } from "./service/top-nav.service";

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-top-nav",
  templateUrl: "./top-nav.component.html",
  styleUrls: ["./top-nav.component.css"],
})
export class TopNavComponent implements OnInit {
  @Output() active1: boolean;
  @Output() active2: boolean;
  @Output() active3: boolean;
  @Output() active4: boolean;
  @Output() active5: boolean;
  @Output() orglist: PersonOrganization[];
  @Output() chosenOrg: PersonOrganization;
  @Output() norgyet: boolean;
  @Output() et_admin: boolean;
  moduleProjects: boolean;
  modulePlanning: boolean;
  modulePortal: boolean;
  moduleWhitelabel: boolean;
  dashActive: boolean = false;
  interestActive: boolean = false;
  projectActive: boolean = false;
  peopleActive: boolean = false;
  planningActive: boolean = false;
  portalActive: boolean = false;
  customerActive: boolean = false;
  orgaccountActive: boolean = false;
  useraccountActive: boolean = false;
  orgId: string;
  showTopNav: boolean = false;
  viewAsCustomer: string = null;

  constructor(
    private router: Router,
    private uievent: UieventhubService,
    private authservice: AuthorizationService,
    private topnavservice: TopNavService,
  ) {
    this.uievent.showAsCustomer$.pipe(untilDestroyed(this)).subscribe((data) => {
      this.viewAsCustomer = data;
    });
  }

  toggleChat() {
    if(SessionHelper.getChatShow() == "false" || !SessionHelper.getChatShow()) {
      if(SessionHelper.getCurrentProject() != null){
        SessionHelper.setChatShow("chat");
      }else{
        SessionHelper.setChatShow("project");
      }
      this.uievent.setshowchatcollapse(true);
    }else{
      SessionHelper.setChatShow("false");
      this.uievent.setshowchatcollapse(false);
      
    }
  }

  isCustomerPortal(): boolean {
    return !!this.viewAsCustomer || !!SessionHelper.getCustomer();
  }
  canEditOrg() {
    if (this.et_admin) {
      return true;
    } else {
      return this.authservice.isAuthorized(
        "orgedit",
        SessionHelper.getChoosenOrg()
      );
    }
  }

  ngOnInit() {
    //this.imgstore.initializaCache();
    if(!this.viewAsCustomer && SessionHelper.getViewAsCustomer()){
    this.viewAsCustomer = SessionHelper.getCustomer() ? JSON.parse(SessionHelper.getCustomer()).customerId : null;
    }
    //console.log('top nav oninit')
    this.orglist = [];
    this.norgyet = true;

    //console.log( this.router.url
    this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //console.log(event.url);
        let url = event.url;
        if (
          (url == "/" || 
          url.startsWith("/login")) ||
          url.startsWith("/register") ||
          url.startsWith("/forgot") ||
          url.startsWith("/reset") ||
          url.startsWith("/confirm") ||
          url.startsWith("/verify") ||
          url.startsWith("/error")
        ) {
          this.showTopNav = false;
        } else {
          this.et_admin = JSON.parse(SessionHelper.getPerson())?.et_admin;
          if(!SessionHelper.getCustomer()){
          this.setModules();
          }
          this.showTopNav = true;

          if (this.router.url.startsWith("/portal")) {
            this.portalActive = true;
            this.dashActive = false;
            this.interestActive = false;
            this.projectActive = false;
            this.peopleActive = false;
            this.planningActive = false;
            this.orgaccountActive = false;
            this.useraccountActive = false;
            this.customerActive = false;
          }
          if (this.router.url.startsWith("/dashboard")) {
            this.portalActive = false;
            this.dashActive = true;
            this.interestActive = false;
            this.projectActive = false;
            this.peopleActive = false;
            this.planningActive = false;
            this.orgaccountActive = false;
            this.useraccountActive = false;
            this.customerActive = false;
          }
          if (this.router.url.startsWith("/interests")) {
            this.portalActive = false;
            this.dashActive = false;
            this.interestActive = true;
            this.projectActive = false;
            this.peopleActive = false;
            this.planningActive = false;
            this.orgaccountActive = false;
            this.useraccountActive = false;
            this.customerActive = false;
          }
          if (this.router.url.startsWith("/projects")) {
            this.portalActive = false;
            this.dashActive = false;
            this.interestActive = false;
            this.projectActive = true;
            this.peopleActive = false;
            this.planningActive = false;
            this.orgaccountActive = false;
            this.useraccountActive = false;
            this.customerActive = false;
          }
          if (this.router.url.startsWith("/people")) {
            this.portalActive = false;
            this.dashActive = false;
            this.interestActive = false;
            this.projectActive = false;
            this.peopleActive = true;
            this.planningActive = false;
            this.orgaccountActive = false;
            this.useraccountActive = false;
            this.customerActive = false;
          }
          if (this.router.url.startsWith("/planning")) {
            this.portalActive = false;
            this.dashActive = false;
            this.interestActive = false;
            this.projectActive = false;
            this.peopleActive = false;
            this.planningActive = true;
            this.orgaccountActive = false;
            this.useraccountActive = false;
            this.customerActive = false;
          }
          if (this.router.url.startsWith("/orgaccount")) {
            this.portalActive = false;
            this.dashActive = false;
            this.interestActive = false;
            this.projectActive = false;
            this.peopleActive = false;
            this.planningActive = false;
            this.orgaccountActive = true;
            this.customerActive = false;
            this.useraccountActive = false;
          }
          if (this.router.url.startsWith("/useraccount")) {
            this.portalActive = false;
            this.dashActive = false;
            this.interestActive = false;
            this.projectActive = false;
            this.peopleActive = false;
            this.planningActive = false;
            this.orgaccountActive = false;
            this.customerActive = false;
            this.useraccountActive = true;
          }
          if (this.router.url.startsWith("/customer")) {
            this.customerActive = true;
            this.portalActive = false;
            this.dashActive = false;
            this.interestActive = false;
            this.projectActive = false;
            this.peopleActive = false;
            this.planningActive = false;
            this.orgaccountActive = false;
            this.useraccountActive = false;
          }
          if(!SessionHelper.getCustomer()){
          this.orglist = JSON.parse(SessionHelper.getPersonOrgs());
          
          this.norgyet = this.orglist.length == 0;
          this.chosenOrg = this.orglist.find(
            (x) => x.organizationId == SessionHelper.getChoosenOrg()
          );
          this.orgId = SessionHelper.getChoosenOrg();
        }
        }
      }
    });
  }

  setModules() {
    function isCurrent(org) {
      return org.organizationId == SessionHelper.getChoosenOrg();
    }

    let orgs = [];
    orgs = JSON.parse(SessionHelper.getPersonOrgs());
    let org = orgs.find(isCurrent);
    //console.log(org);
    if (org.modules) {
      if (org.modules.indexOf("projects") >= 0) {
        this.moduleProjects = true;
      } else {
        this.moduleProjects = false;
      }
      if (org.modules.indexOf("planning") >= 0) {
        this.modulePlanning = true;
      } else {
        this.modulePlanning = false;
      }
      if (org.modules.indexOf("portal") >= 0) {
        this.modulePortal = true;
      } else {
        this.modulePortal = false;
      }
      if (org.modules.indexOf("whitelabel") >= 0) {
        this.moduleWhitelabel = true;
        SessionHelper.setIsWhitelabel();
      } else {
        this.moduleWhitelabel = false;
        SessionHelper.clearIsWhitelabel();
      }
      if (org.modules.indexOf("hubspot") >= 0) {
        SessionHelper.setHubspot();
      } else {
        SessionHelper.clearHubspot();
      }
    }
  }
  disableCustomerView() {
    let custId = this.viewAsCustomer;
    SessionHelper.clearCustomer();
    SessionHelper.clearViewAsCustomer();
    this.uievent.setViewAsCustomer(null);
    this.router.navigate(["/customer/"+custId]);
  }

  noOrgYet() {
    return this.norgyet;
  }
  setLoader(loader: string) {
    this.uievent.clearLoaders();
    this.uievent.addLoader(loader);
    this.uievent.addLoader('personname');
    
  }
}
